import React, { useEffect, useState } from "react";
import { observer, inject } from "mobx-react";
import { useNavigate } from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";
import { checkCNP } from "Utils";
import Button from "@mui/material/Button";
import { TextFieldMask, PasswordField, LoginTimer, Checkbox,TooltipLine } from "TemplateCerere";
import { ArrowRight } from "@mui/icons-material";
import Typography from "@mui/material/Typography";
import OtpInput from "react-otp-input";
import FormHelperText from "@mui/material/FormHelperText";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import Link from "@mui/material/Link";

import { Prompt } from "TemplateCerere";
import { ProgressBar } from "TemplateCerere";

function RegisterActualizareDate(props) {
  const navigateUrl = useNavigate();
  const { updateValue, sendPhone, confirmPhone, errors } = props.store;
  const {
    isMobile,
    preventGoBack,
    preventGoBackMessage,
    codeRequest,
    downloadAcord,
  } = props.store;

  const[jprop,setJprop] = useState({});
  //termeni si conditii
  const[tc,setTc] = useState( { value: false, error: null })
  //nota de informare
  const[ni,setNi] = useState( { value: false, error: null })
  const[cnp, setCnp] = useState({ value: "" , error: null });
  const[phone, setPhone] = useState({ value: null, error: null });
  const[firstDigits, setFirstDigits] = useState("");
  const[lastDigits, setLastDigits] = useState("");
  const[smsCode, setSmsCode] = useState();
  const[cetatean, setCetatean] = useState(true);
  const[amCard, setAmCard] = useState(true);
    
  useEffect(() => {
    setJprop(props.store.jprop || {})
  }, [props.store?.jprop]);
  useEffect(() => {
    setPhone({ value: null, error: null })
  }, [cetatean]);
  useEffect(() => {
    window.addEventListener("load", (event) => {
      event.preventDefault();
    });
    updateValue({ preventGoBack: true });
  }, []);

  const validare = () => {
    var errorMsgs = [];
      if (!tc.value) {
        errorMsgs.push({
          msg: "[ADPF02]Trebuie sa acceptati termenii si conditiile",
          ctrl: setTc,
          fld: tc
        });
      }
      if (!ni.value) {
        errorMsgs.push({
          msg: "[ADPF03]Trebuie sa acceptati nota de informare",
          ctrl: setNi,
          fld: ni
          
        });
      }

      if (cetatean & !(phone?.value?.length === 10)) {
        errorMsgs.push({
          msg: "[ADPF08]Introduceti corect numarul de telefon (de forma: 07xxxxxxxx)!",
          ctrl: setPhone,
          fld: phone
        });
      }
      if (
        !cetatean & !(phone?.value?.length >= 8 && phone?.value?.length <= 15)
      ) {
        errorMsgs.push({
          msg: "Introduceti corect numarul de telefon (Incepe cu 00 si contine intre 8 si 15 cifre)!",
          ctrl: setPhone,
          fld: phone
        });
      }
      if (cetatean & !checkCNP(cnp.value)) {
        errorMsgs.push({
          msg: "[ADPF05]Campul CNP este incorect!",
          ctrl: setCnp,
          fld: cnp
         });
      }
      if (
        amCard &&
        (!firstDigits ||
          firstDigits.length !== 4 ||
          isNaN(firstDigits))
      ) {
        errorMsgs.push(
          "[LP005] Introduceti corect PRIMELE 4 cifre ale  numarului de card!"
        );
      }
      if (
        amCard &&
        (!lastDigits ||
          lastDigits.length !== 4 ||
          isNaN(lastDigits))
      ) {
        errorMsgs.push(
          "[LP006] Introduceti corect ULTIMELE 4 cifre ale  numarului de card!"
        );
      }
    errorMsgs.forEach((e) => {
      if (e.ctrl) {
        var fld={...e.fld};
        fld.error = errors.processMsg(e.msg);
        e.ctrl(fld);
      }
    });
  return errorMsgs;
  };

  const handlerConfirmPhone = () => {
    var errorMsgs = validare();
    if (!smsCode || smsCode.length !== 6) {
      errorMsgs.push("[OPF10]Introduceti codul primit prin SMS!");
    }
    if (errorMsgs.length !== 0) {
      errors.open(errorMsgs);
      return;
    }
    updateValue({ phone: phone.value, smsCode: smsCode, preventGoBack: false });
    confirmPhone(
      {
        acord_tc: tc.value ? "1" : "0", //termeni si conditii
        acord_ni: ni.value ? "1" : "0", //nota de informare
        cnp: cnp.value,
        firstDigits: amCard ? firstDigits : "",
        lastDigits: amCard ? lastDigits : "",
        cetatean: cetatean ? "1" : "0",
      },
      navigateUrl
    );
  };
  const handlerSendPhone = async () => {

    var errorMsgs = validare();
    if (errorMsgs.length !== 0) {
      errors.open(errorMsgs, false);
      return;
    }
    updateValue({ phone: phone.value });
    await sendPhone({
      cnp: cnp.value,
      firstDigits: amCard ? firstDigits : "",
      lastDigits: amCard ? lastDigits : "",
      cetatean: cetatean ? "1" : "0",
    });

  };
  return (
    <div className={"paper-toolbar" + (isMobile ?  " first":"")}>
      <Prompt when={preventGoBack} message={preventGoBackMessage} />
      {isMobile && jprop.theme === "retail" && (
        <div className="nav-bar">
          <ProgressBar
            prevStep={false}
          />
        </div>
      )}

      <CssBaseline />
      <div className="login-content">
        
        <p className="page-title">Buna,</p>
      <p className="normal-text">
        Ne bucuram sa te intalnim, chiar si virtual.
      </p>
      <p>
        Pentru a incepe procesul de Actualizare a datelor tale personale este
        important sa te Autentifici, completand campurile de mai jos:
      </p>
      <div className="form switch-group">
        <div className="label">Esti cetatean roman?</div>
        <FormControlLabel
          control={
            <Switch
              color="primary"
              width="100px"
              checked={cetatean}
              onChange={(prop) => {
                setCetatean(prop.target.checked);
              }}
            />
          }
          label={cetatean ? "Da" : "Nu"}
          labelPlacement="top" 
        />
      </div>
      <TooltipLine
        className="form"
        tooltip="In cazul in care nu esti cetatean roman si nu ai un CNP, este necesar sa te autentifici cu Numarul de identificare fiscala (NIF) ."
      >
        <PasswordField
          //autoFocus
          id="cnp"
          label={cetatean ? "CNP *" : "NIF/Serie si nr. act de identitate *"}
          defaultValue={cnp?.value}
          className="login-pwd"
          variant="outlined"
          onBlur={(prop) =>
            setCnp({value:prop.target.value?.toString().toUpperCase(), error:null})
          }
          mask={cetatean ? "0000000000000" : null}
          error={!!cnp.error}
          helperText={cnp.error}
          type="tel"
        />
      </TooltipLine>
      <div className="form switch-group">
        <div className="label">Detin card de debit la Patria Bank:</div>
        <FormControlLabel
          control={
            <Switch
              color="primary"
              width="100px"
              checked={amCard}
              onChange={(prop) => {
                setAmCard(prop.target.checked);
              }}
            />
          }
          label={amCard ? "Da" : "Nu"}
          labelPlacement="top"
        />
      </div>
      {amCard && (
        <div className="form">
          <Typography className="label">Numarul Cardului</Typography>
          <div className="hlist">
            <TextFieldMask
              variant="outlined"
              margin="normal"
              //required
              id="firstDigits"
              label="Primele 4 Cifre"
              name="firstDigits"
              defaultValue={firstDigits?? ""}
              onBlur={(prop) => setFirstDigits(prop.target.value)}
              mask="0000"
              className="card center"
            />
            <TextFieldMask
              variant="outlined"
              margin="normal"
              defaultValue="* * * *"
              className="card disabled center"
              disabled
            />
            <TextFieldMask
              variant="outlined"
              margin="normal"
              defaultValue="* * * *"
              className="card disabled center"
              disabled
            />
            <TextFieldMask
              variant="outlined"
              margin="normal"
              required
              id="lastDigits"
              label="Ultimele 4 Cifre"
              name="lastDigits"
              className="card center"
              defaultValue={lastDigits ?? ""}
              onBlur={(prop) => setLastDigits(prop.target.value)}
              mask="0000"
            />
        </div>
      </div>
      )}
      <div className="acord">
        <div className="acord">
          <Checkbox
            name="tc"
            checked={tc?.value}
            onChange={(event)=>{ 
                setTc({value:event.target.checked, error: false});
            }}
            color="primary"
          />
          <div className="acord-txt">
            Accept
            <Link onClick={() => downloadAcord(1)} className="termenii">
              Termenii si Conditiile Generale
            </Link>
            de utilizare a Platformei Online *
            <FormHelperText error={!!tc?.error}>{tc?.error}</FormHelperText>
          </div>
        </div>
      </div>
      <div className="acord">
        <Checkbox
          name="ni"
          checked={ni?.value}
          onChange={(event)=>{ 
              setNi({value:event.target.checked, error: false});
          }}
          color="primary"
        />
        <div className="acord-txt">
          Am citit si am inteles prevederile
          <Link onClick={() => downloadAcord(2)} className="termenii">
            Notei de informare
          </Link>
          vizand prelucrarea datelor cu caracter personal pentru scopul
          desfasurarii sesiunii pe Platforma Online *
          <FormHelperText error={!!ni?.error}>{ni?.error}</FormHelperText>
        </div>
      </div>
      <div className="form">
        <TextFieldMask
          variant="outlined"
          margin="normal"
          required
          fullWidth
          id="phone"
          label="Nr Telefon"
          defaultValue={phone?.value??(cetatean?"07":"")}
          onBlur={(prop) => setPhone({value:prop.target.value, error:null})}
          className="phone"
          mask={cetatean ? "\\0700000000" : Number}
          error={!!phone.error}
          helperText={phone.error}
          type="tel"
        />
      </div>
      <p className="footer-text mkt">
        Campurile marcate cu * sunt obligatoriu de completat
      </p>
      <Button
        variant="contained"
        color="primary"
        className="login-btn"
        onClick={handlerSendPhone}
        endIcon={<ArrowRight fontSize="large" />}
      >
        Trimite Cod
      </Button>
      <Typography variant="subtitle2">
        Introdu codul primit prin SMS:
      </Typography>
      <OtpInput
        value={smsCode ? smsCode : ""}
        onChange={(value) => setSmsCode(value)}
        numInputs={6}
        renderInput={(props) => <input {...props} disabled={!!codeRequest} />}
        inputStyle="MuiInputBase-root MuiInputBase-input MuiOutlinedInput-input otp-input"
        focusStyle="otp-focus"
        disabledStyle="MuiInputBase-root Mui-disabled"
        inputType="number"
        containerStyle="otp"
      />
      <FormHelperText error={false}></FormHelperText>
      <LoginTimer sendPhone={handlerSendPhone} />
      <Button
        variant="contained"
        color="primary"
        /*className="login-btn"*/
        onClick={handlerConfirmPhone}
        endIcon={<ArrowRight fontSize="large" />}
        disabled={!smsCode}
      >
        Confirma telefon
      </Button>

      </div>
    </div>
  );
}
export default inject((stores) => ({ store: stores.mainStore }))(
  observer(RegisterActualizareDate)
);
